var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h2',{staticClass:"font-bold text-xl mb-6"},[_vm._v("Push Notification")]),_c('TextEditor')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }